/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formattachment_Validation1Inputs */

const ja_contact_formattachment_validation1 = /** @type {(inputs: Contact_Formattachment_Validation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`それぞれのファイルは2MB以内に収めてください。`)
};

const en_contact_formattachment_validation1 = /** @type {(inputs: Contact_Formattachment_Validation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please keep each file under 2MB.`)
};

/**
* | output |
* | --- |
* | "Please keep each file under 2MB." |
*
* @param {Contact_Formattachment_Validation1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formattachment_validation1 = /** @type {((inputs?: Contact_Formattachment_Validation1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formattachment_Validation1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formattachment_validation1(inputs)
	return en_contact_formattachment_validation1(inputs)
});
export { contact_formattachment_validation1 as "contact_formAttachment_validation" }